function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import { breakpoint } from '../../../vendorjs/breakpoint-helper.vendor';
export var breadcrumbsBehavior = function breadcrumbsBehavior() {
  Alpine.data('breadcrumbsBehavior', function () {
    return {
      dropDownIsOpen: false,
      init: function init() {
        this.dropDownIsOpen = false;
        this.initBreadcrumbs();
      },
      initBreadcrumbs: function initBreadcrumbs() {
        var breadcrumbs = this.$el;
        var container = breadcrumbs.querySelector('.m-breadcrumbs__navigation');
        var breadcrumbsContainer = breadcrumbs.querySelector('.m-breadcrumbs__navigation ol.m-breadcrumbs__listings');
        var breadcrumbsElementsArray = _toConsumableArray(breadcrumbsContainer.querySelectorAll('li'));
        var containerWidth = container.offsetWidth;
        var breadcrumbsContainerWidth = breadcrumbsContainer.scrollWidth;
        var buttonDropdown = breadcrumbs.querySelector('.m-breadcrumbs__trigger-container');
        var breadcrumbInnerWidth = 0;
        if (breadcrumbsContainerWidth > containerWidth) {
          breadcrumbInnerWidth = buttonDropdown.offsetWidth + 10;
          buttonDropdown.classList.remove('hidden');
          breadcrumbsElementsArray.forEach(function (el) {
            breadcrumbInnerWidth += el.offsetWidth;
          });
          var _loop = function _loop() {
            var newBreadcrumbInnerWidth = buttonDropdown.offsetWidth + 10;
            if (breadcrumbsElementsArray.length > 1) {
              breadcrumbsElementsArray[0].classList.add('hidden');
            }
            breadcrumbsElementsArray.forEach(function (el) {
              newBreadcrumbInnerWidth += el.offsetWidth;
            });
            breadcrumbsElementsArray = breadcrumbsElementsArray.slice(1);
            breadcrumbInnerWidth = newBreadcrumbInnerWidth;
          };
          while (breadcrumbInnerWidth > containerWidth) {
            _loop();
          }
        }
        var updatedBreadcrumbsElementsArray = _toConsumableArray(breadcrumbsContainer.querySelectorAll('li'));
        updatedBreadcrumbsElementsArray[updatedBreadcrumbsElementsArray.length - 1].classList.remove('shrink-0');
      },
      clicked: function clicked() {
        var breadcrumbs = this.$el;
        this.dropDownIsOpen = !this.dropDownIsOpen;
        breadcrumbs.classList.add('m-breadcrumbs__trigger--active');
      },
      clickedOutside: function clickedOutside() {
        var breadcrumbs = this.$el;
        this.dropDownIsOpen = false;
        breadcrumbs.classList.remove('m-breadcrumbs__trigger--active');
      }
    };
  });
};